var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "MuiSvgIcon-root jss69",
    focusable: "false",
    viewBox: "0 0 24 24",
    "aria-hidden": "true",
    tabIndex: -1,
    title: "HomeWorkOutlined",
    "data-ga-event-category": "material-icons",
    "data-ga-event-action": "click",
    "data-ga-event-label": "HomeWorkOutlined",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 15h2v2h-2zm0-4h2v2h-2zm0-4h2v2h-2zm-3.26 0l1.26.84V7z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 3v1.51l2 1.33V5h9v14h-4v2h6V3z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.17 5.7L15 10.25V21H1V10.48L8.17 5.7zM10 19h3v-7.84L8.17 8.09 3 11.38V19h3v-6h4v6z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.f1aafd4be285fb5394ce6f5342988936.svg";
export { ForwardRef as ReactComponent };